<template>
  <div class="live-index">
    <section class="video-bg">
      <div
        class="video-container maxW"
        :class="{ enUsActive: $i18n.locale === 'en-us' }"
      >
        <!-- <div class="video-container maxW" v-loading="videoLoading" :element-loading-text="$t('global.loading')" element-loading-background="rgba(0, 0, 0, 1)"> -->
        <!-- 跳到直播间按钮 -->
        <router-link
          v-if="videoShowFlag"
          :to="{ path: '/home/liveRoom', query: { id: liveId } }"
        >
          <el-button type="primary" class="top-enter-btn">{{
            $t("homepage.enterLive")
          }}</el-button>
        </router-link>
        <!-- 视频播放器 -->
        <template v-if="videoShowFlag">
          <!-- 跳到直播间按钮 -->
          <router-link :to="{ path: '/home/liveRoom', query: { id: liveId } }">
            <el-button type="primary" class="top-enter-btn">{{
              $t("homepage.enterLive")
            }}</el-button>
          </router-link>
          <!-- 视频播放器 -->
          <!-- <hjPlayer id="hjPlayer" height="691" :playerOption.sync="playerOption"></hjPlayer> -->
          <liveDPlayer
            v-if="isM3u8 == 2 && videoShowFlag && playerOption.play_url"
            :live_Options.sync="playerOption"
          ></liveDPlayer>
          <m3u8Dplayer
            v-if="m3u8Data.pc_play_url && isM3u8 === 1 && videoShowFlag"
            :options="m3u8Data"
          >
          </m3u8Dplayer>
        </template>
        <!-- 直播权限框 -->
        <div class="unlogin-box" v-if="isLimitFlag">
          <div class="unlogin-container">
            <img src="../../../assets/images/live-lock.png" alt="lock" />
            <div class="limit-tips">
              <!-- 未登录 -->
              <!-- <template>
                <p class="not-allow">{{ $t('homepage.forbitted') }}</p>
                <span class="need-login" v-if="userId == 0">
                  <i @click="goToLogin">{{ $t('homepage.loginFirst') }}></i>
                </span>
              </template> -->
              <!-- 已登录 -->
              <!-- <template v-if="userId != 0">
                <span class="check-area" v-if="!areaFlag" @click="checkTheArea">{{ $t('homepage.checkArea') }}</span>
                <span class="forbid-area" v-else>{{ $t('homepage.noAllow') }}</span>
              </template> -->
            </div>
            <div class="forbid-content" v-if="areaFlag">
              <template v-for="(item, index) of limitInfo">
                <span :key="index" v-if="index < 16"
                  >{{ item.name }} &nbsp;&nbsp;</span
                >
              </template>
              <span
                class="check-more-btn"
                v-if="limitInfo.length > 17"
                @click="dialogVisible = true"
                >{{ $t("homepage.more") }}></span
              >
            </div>
          </div>
        </div>
        <!-- 直播密码框 -->
        <div class="live-password-box" v-if="passwordFlag">
          <div class="container">
            <img src="../../../assets/images/live-lock.png" alt="lock" />
            <div class="tips">
              <p>{{ $t("homepage.pswSetted") }}</p>
              <p>
                {{
                  $t("homepage.getPsw", { speaker: bigLiveData.teachername })
                }}
              </p>
            </div>
            <p class="enter-tip">{{ $t("homepage.inputPsw") }}</p>
            <template>
              <div class="code-box">
                <div class="code-input-line"></div>
                <el-input
                  class="code-input"
                  v-model="passCode"
                  maxlength="6"
                ></el-input>
              </div>
            </template>
            <el-button
              type="primary"
              class="password-enter-btn"
              @click="enterLiveRoom"
              >{{ $t("homepage.enterLive") }}
            </el-button>
          </div>
        </div>
      </div>
    </section>
    <section class="vStatus-content">
      <div class="vStatus-title maxW clear">
        <div class="titleNav clear">
          <div class="titleNav-l fl">
            <span
              type="text"
              :class="[liveType == 2 ? 'blueC' : '']"
              @click="toggleStatus(2)"
              >{{ $t("homepage.living") }}</span
            >
            <span
              type="text"
              :class="[liveType == 1 ? 'blueC' : '']"
              @click="toggleStatus(1)"
              >{{ $t("homepage.notStart") }}</span
            >
          </div>
          <div class="titleNav-r fr">
            <el-date-picker
              v-model="liveDate"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              clearable
              :placeholder="`- ${$t('global.selectDate')} -`"
            ></el-date-picker>
            <i class="ipng but_Date01_up"></i>
          </div>
        </div>
        <ul class="hot-video clear">
          <li
            class="i-hotList wow bounceInLeft fl"
            v-for="(item, index) of liveListData"
            :key="index"
          >
            <div class="video-poster" @click="linkToRoom(item.id)">
              <img :src="BASE_URL + item.picture" onerror />
            </div>
            <p :title="item.name" class="ellipsis" @click="linkToRoom(item.id)">
              {{ item.name }}
            </p>
            <div class="hot-type clear">
              <!-- <router-link :to="{path: '/teach/space', query: {id: item.create_id}}"> -->
              <a href="javacript:;">
                <span>
                  <img :src="item.avatar_path" />
                </span>
                {{ item.teachername }}
              </a>
              <!-- </router-link> -->
              <span class="hold-time">{{ item.time_string }}</span>
            </div>
          </li>
          <div class="no-data-tip" v-if="!liveListData">
            <i class="ipng image_state01"></i>
            <p>{{ $t("global.noData") }}</p>
          </div>
        </ul>
        <div class="pageBox">
          <el-pagination
            v-if="total_number > page_size"
            @current-change="change_page"
            :page-size="page_size"
            :current-page="page_index"
            layout="total,prev, pager, next,jumper"
            :total="total_number"
          ></el-pagination>
        </div>
      </div>
    </section>
    <el-dialog
      :title="$t('homepage.noAllow')"
      class="areaDialog"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <span v-for="(item, index) of limitInfo" :key="index"
        >{{ item.name }} &nbsp;&nbsp;</span
      >
    </el-dialog>
  </div>
</template>

<script>
// 引入直播组件
// import hjPlayer from "@/components/common/hjPlayer";
import liveDPlayer from "@/components/common/liveDPlayer";
import m3u8Dplayer from "@/components/common/m3u8Dplayer";
export default {
  components: {
    // hjPlayer,
    liveDPlayer,
    m3u8Dplayer,
  },
  data() {
    return {
      userId: this.$g.user_id, //用户id
      keyword:
        this.$route.query.keyword == undefined ? "" : this.$route.query.keyword, //首页搜索跳转到此页面时带的关键字
      videoShowFlag: false, //默认不显示视频
      // 大直播详细数据
      // videoLoading: false, //初始化加载提示
      bigLiveData: {},
      playerOption: {
        type: "flv",
        play_url: "",
      },
      liveType: 2, //默认显示直播中的列表
      liveListData: [], //直播中/未开始/选日期
      //日期选择器（限制:不能选已过去的日期）
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      liveDate: "", //日期
      live_page_max: 0,
      //   分页
      page_index: 1,
      page_size: 4,
      total_number: 0,
      // 当前播放中的视频
      passwordFlag: false, //默认不显示密码输入框
      liveId: null, //大直播的id
      passCode: "", //输入的直播密码
      dialogVisible: false, //查看更多限制弹窗
      isLimitFlag: false, //默认不显示限制条件框
      areaFlag: false, //查看范围详情信息默认不显示
      limitInfo: [], //被限制的具体信息数据
      liveInterval: null, //计时器，用于检测直播是否被删除
      loginFlag: false,

      isM3u8: "", // 判断是否可以进行清晰度切换，flv不可以，m3u8可以
      m3u8Data: {
        pc_play_url: "",
      },
    };
  },
  created() {
    // this.checkUserLogin()
    this.getBigLive();
    this.getLiveData();
    this.getIsFlv();
  },
  mounted() {
    let container = document.querySelector(".video-container");
    container.style.backgroundImage = `url(${sessionStorage.getItem(
      "host_addr"
    )}/static/default/liveall_preview.png)`;
    // this.openLoading();
  },
  watch: {
    liveDate(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getLiveData();
      }
    },
  },
  beforeDestroy() {
    //计时器clearInterval方法，是根据计时器ID来清除的
    clearInterval(this.liveInterval);
  },
  methods: {
    getM3u8Data(id) {
      let success = (res) => {
        this.m3u8Data.pc_play_url = res.data.hls_live_path;
      };
      this.$ajax({
        url: "/appapi/live/getLiveHls",
        method: "get",
        params: {
          id: id,
        },
        func: { success },
      });
    },
    getIsFlv() {
      let success = (res) => {
        this.isM3u8 = res.data.m3u8_show;
      };
      let fail = (res) => {
        this.isM3u8 = 2;
      };
      this.$ajax({
        url: "/api/video/live_app_show",
        method: "get",
        params: {
          type: 1,
        },
        func: { success, fail },
      });
    },
    // openLoading() {
    // 	this.videoLoading = true;
    // 	setTimeout(() => {
    // 		this.videoLoading = false;
    // 	}, 2000);
    // },
    // 获取大直播数据
    getBigLive() {
      let success = (res) => {
        if (is_empty(res.data.data)) {
          this.videoShowFlag = false;
        } else {
          this.bigLiveData = res.data.data[0]; //大直播详细数据
          this.liveId = res.data.data[0].id; //大直播id
          this.getM3u8Data(this.liveId);
          //设置计时器检查直播是否被删除
          this.liveInterval = setInterval(this.checkLiveEnd, 20000);
          // 如果权限和密码都不设置
          if (
            res.data.data[0].limit_type == 0 &&
            res.data.data[0].password == ""
          ) {
            this.playerOption.play_url = res.data.data[0].play_url; //赋值播放流地址
            this.videoShowFlag = true; //显示视频播放器

            return;
          }

          // this.checkLivePass(res.data.data[0])
          // 若视频设置了限制，显示权限弹框
          if (res.data.data[0].limit_type != 0) {
            this.isLimitFlag = true;
            this.checkUserLimit(this.liveId);
          } else {
            //没被限制权限，则检查密码的情况
            this.checkLivePass(res.data.data[0]);
          }
        }
      };
      this.$ajax({
        url: "api/live/live_list",
        method: "get",
        params: {
          page_index: 1,
          page_size: 1,
          live_type: 2,
        },
        func: {
          success: success,
        },
      });
    },
    //查看一下用户有没有登录，若没登录，则不给看直播
    checkUserLogin() {
      let success = (res) => {
        if (res.data == "no") {
          this.$message.warning(this.$t("homepage.liveNeedLogin"));
          this.loginFlag = false;
        } else {
          this.loginFlag = true;
        }
      };
      let fail = (res) => {
        this.loginFlag = true;
      };
      this.$ajax({
        url: "api/setting/check_video_live_user",
        method: "get",
        params: {
          type: 1,
        },
        func: {
          success: success,
          fail: fail,
        },
      });
    },
    // 检测直播是否被删除：
    checkLiveEnd() {
      let success = (res) => { };
      let fail = (res) => {
        this.$message.warning(this.$t("homepage.liveOver"));
        clearInterval(this.checkingInterval);
        window.location.href = window.location.href;
      };
      this.$ajax({
        url: "api/live/check_is_liveend",
        method: "get",
        params: {
          liveid: this.liveId,
        },
        func: {
          success: success,
          fail: fail,
        },
      });
    },
    // 先不检查了
    checkLivePass(liveData) {
      // if (this.userId == 0) {
      //   return
      // }
      // let success = res => {
      //   let livePass = res.data.userinfo.live_pass + "" //直播id字符串，用户曾看过，且输入过正确密码的
      //   let flag = livePass.split(",").indexOf(liveData.id + "")

      if (liveData.password == "") {
        this.isLimitFlag = false; //关闭权限限制框
        this.dialogVisible = false; //关闭权限限制详情弹窗
        this.playerOption.play_url = bigLiveData.play_url; //赋值播放流地址
        this.videoShowFlag = true; //显示视频播放器
      } else {
        this.isLimitFlag = false;
        this.dialogVisible = false;
        this.passwordFlag = true; //显示密码输入框
      }
      // }
      // let fail = res => {
      //   console.log('fail', res)
      // }
      // this.$ajax({
      //   url: "api/login/new_login",
      //   method: "get",
      //   params: {},
      //   func: {
      //     success,
      //     fail
      //   }
      // })
    },
    //去登录
    goToLogin() {
      this.$router.push("/user-login");
      // let host_addr = sessionStorage.getItem("host_addr");
      // window.location.href = host_addr + "/index/login/index";
    },
    //查看限制范围的详情
    checkTheArea() {
      this.areaFlag = true;
    },
    //检用户的观看权限
    checkUserLimit(liveId) {
      // if (this.userId == 0) {
      //   return
      // }
      let success = (res) => {
        // 若被限制，提示用户他被禁止观看，并显示限制范围具体信息
        if (res.data == "no") {
          this.$message.warning(this.$t("homepage.forbitted"));
          this.getLimitArea(liveId);
        } else {
          //没被限制权限，则检查密码的情况
          this.checkLivePass(this.bigLiveData);
        }
      };
      this.$ajax({
        url: "api/live/get_islimit_by_live_user_id",
        method: "get",
        params: {
          live_id: liveId,
          user_id: this.userId,
        },
        func: {
          success: success,
        },
      });
    },
    //获取直播限制范围信息用于展示
    getLimitArea(liveId) {
      let success = (res) => {
        this.limitInfo = res.data;
      };
      this.$ajax({
        url: "api/live/get_live_limit",
        method: "get",
        params: {
          live_id: liveId,
        },
        func: {
          success: success,
        },
      });
    },
    // 输入直播密码，进行校验：
    enterLiveRoom() {
      if (this.passCode == "") {
        this.$message.error(this.$t("register.pswEmpty"));
        return;
      } else if (this.passCode.length < 6) {
        this.$message.error(this.$t("register.psw6"));
        return;
      }
      let success = (res) => {
        if (res.status == "success") {
          this.$message.success(res.msg);
          this.passwordFlag = false;
          this.playerOption.play_url = this.bigLiveData.play_url; //赋值播放流地址
          this.videoShowFlag = true;
        } else {
          this.$message.error(res.msg);
        }
      };
      this.$ajax({
        url: "api/live/check_live_password",
        method: "get",
        params: {
          id: this.liveId,
          password: this.passCode,
        },
        func: {
          success: success,
        },
      });
    },

    // tab切换 直播中live_type：2  / 未开始live_type：1
    toggleStatus(type) {
      this.liveType = type;
      this.getLiveData();
    },
    // 获取直播的列表数据
    getLiveData() {
      let success = (res) => {
        this.liveListData = res.data.data;
        this.live_page_max = res.data.page_max;
        this.liveListData.forEach(item => {
          if (item.avatar_path.includes('/static/default/user_preview-1.png') || item.avatar_path.includes('/public/picture')) {
            item.avatar_path = this.BASE_URL + item.avatar_path
          }
        });
      };
      this.$ajax({
        url: "api/live/live_list",
        method: "get",
        params: {
          // page_index: this.page_index,
          // page_size: this.page_size,
          live_type: this.liveType,
          keyword: this.keyword,
          date: this.liveDate,
        },
        func: {
          success: success,
        },
      });
    },
    // 分页
    change_page(val) {
      this.page_index = val;
      this.getLiveData();
    },
    //跳去直播间：
    linkToRoom(_id) {
      if (this.liveType == 2) {
        this.$router.push({
          path: "/home/liveRoom",
          query: {
            id: _id,
          },
        });
      } else {
        this.$message.warning(this.$t("homepage.notStart"));
      }
    },
  },
};
</script>
<style lang="scss">
$bg_3: #ffffff; //white - bg
$sc_3: #333333;
$shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
$shadow2: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
$sc_6: #E62125; //Main color

.i_transition {
  -moz-transition: all 0.35s ease-in;
  -webkit-transition: all 0.35s ease-in;
  -o-transition: all 0.35s ease-in;
  transition: all 0.35s ease-in;
}

.live-index {
  .video-bg {
    height: 674px;
    padding: 50px 0;
    background: url("../../../assets/images/bgc.png") no-repeat;
  }

  .video-container {
    height: 100%;
    position: relative;
    // background-image: url("../../../assets/images/image_cn_couse.png");
    background-size: 100% 100%;

    &:hover .top-enter-btn {
      opacity: 1;
      visibility: visible;
    }

    .top-enter-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 666;
      opacity: 0;
      visibility: hidden;
    }

    .video-background-image {
      height: 100%;
      background-image: url("../../../assets/images/image_couse.png");
      background-size: 100% 100%;
    }
  }

  .enUsActive {
    background-image: url("../../../assets/images/image_couse.png");
    background-size: 100% 100%;
  }

  .unlogin-box {
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.6);
    position: relative;

    .unlogin-container {
      display: inline-block;
      width: 644px;
      height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      /*height的一半*/
      margin-left: -322px;
      /*width的一半*/
    }

    .limit-tips {
      margin-top: 40px;
      font-size: 16px;

      .need-login {
        color: #909eaf;

        i {
          color: #E62125;
          padding-left: 10px;
        }
      }

      .not-allow {
        font-size: 18px;
        color: #b9d9ff;
        line-height: 24px;
        margin: 26px 0 38px;
      }

      .check-area {
        color: #E62125;
        cursor: pointer;
        line-height: 21px;
      }

      .forbid-area {
        color: #909eaf;
        line-height: 21px;
      }
    }

    .forbid-content {
      padding: 20px 0 0;
      text-align: center;

      span {
        margin-left: 5px;
        font-size: 16px;
        color: #fff;
        line-height: 21px;
      }

      .check-more-btn {
        color: #E62125;
        cursor: pointer;
      }
    }
  }

  .live-password-box {
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #000;
    position: relative;

    .container {
      display: inline-block;
      width: 400px;
      height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      /*height的一半*/
      margin-left: -200px;
      /*width的一半*/
    }

    .tips {
      margin-top: 52px;

      p {
        line-height: 28px;
      }

      p:nth-child(1) {
        font-size: 16px;
        color: #fff;
      }

      p:nth-child(2) {
        font-size: 14px;
        color: #fff;
        text-align: left;
        padding-left: 1em;
      }
    }

    .enter-tip {
      font-size: 12px;
      color: #cfcfcf;
      margin: 34px 0;
      text-align: left;
    }

    .error-tip {
      font-size: 16px;
      color: #ff4949;
      margin: 10px 0 25px;
      text-align: left;
    }

    .code-box {
      width: 424px;
      height: 60px;
      position: relative;
      margin: 0 0 20px 10px;

      .code-input-line {
        position: absolute;
        left: 0;
        bottom: 0;
        content: "";
        color: #fff;
        width: 380px;
        height: 4px;
        background-image: linear-gradient(to right,
            #fff 0%,
            #fff 90%,
            transparent 50%);
        background-size: 64px 2px;
        background-repeat: repeat-x;
      }

      .code-input {
        position: absolute;
        left: 0;
        top: 0;

        .el-input__inner {
          border: 1px solid transparent;
          height: 65px;
          line-height: 65px;
          color: #fff;
          font-size: 40px;
          letter-spacing: 45px;
          background-color: transparent;
        }
      }
    }

    .password-enter-btn {
      padding: 0;
      width: 380px;
      height: 40px;
    }
  }

  #videoPlayer {
    height: 674px;
  }

  .video-js {
    width: 100%;
    height: 100%;

    .vjs-control-bar {
      .vjs-progress-control {
        margin-right: 45px;
      }
    }
  }

  .vStatus-content {
    min-height: 400px;
  }

  .titleNav {
    padding: 20px 0;

    .titleNav-l {
      display: inline-block;

      span {
        display: inline-block;
        font-size: 14px;
        color: #666;
        height: 38px;
        line-height: 38px;
        cursor: pointer;
        margin-right: 40px;
      }

      .blueC {
        color: #338efc;
        border-bottom: 2px solid#338efc;
      }
    }

    .titleNav-r {
      position: relative;

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 240px;
      }

      .el-input__prefix {
        display: none;
      }

      .el-input--suffix .el-input__inner {
        height: 40px;
        line-height: 40px;
        border-radius: 4px 0 0 4px;
        border: none;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
      }

      .but_Date01_up {
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
        position: absolute;
        right: 0;
        pointer-events: none;
        cursor: pointer;
      }
    }
  }

  .no-data-tip {
    height: 300px;
    text-align: center;
    color: #666;
    background-color: #fff;
    margin-bottom: 20px;

    i {
      margin: 35px 0;
    }

    p {
      font-size: 14px;
      color: #888;
    }
  }

  // openclass:
  .open-class {
    border-top: 1px dashed #cfcfcf;
    overflow: hidden;

    .bgc-img {
      height: 90px;
      margin: 30px 0;
      // background: url("../../../public/images/image04.png") no-repeat;
    }
  }

  .i-hotList {
    width: 290px;
    max-height: 300px;
    background-color: $bg_3;
    -webkit-box-shadow: $shadow2;
    -moz-box-shadow: $shadow2;
    box-shadow: $shadow2;
    -moz-border-radius: 3px;
    border-radius: 3px;
    overflow: hidden;
    margin: 0 13px 20px 0;
    @extend .i_transition;

    &:nth-of-type(4n) {
      margin: 0 0 20px 0;
    }

    &:hover {
      -webkit-box-shadow: $shadow;
      -moz-box-shadow: $shadow;
      box-shadow: $shadow;

      >a {
        color: $sc_6;

        &:after {
          opacity: 1;
        }
      }
    }

    .video-poster {
      height: 140px;
      overflow: hidden;
      position: relative;
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      @extend .i_transition;
      cursor: pointer;

      >img {
        width: 100%;
        height: 100%;
      }

      &:after {
        content: "";
        opacity: 0;
        background: linear-gradient(180deg,
            rgba(0, 0, 0, 0.01) 2%,
            rgba(0, 0, 0, 0.2));
        transition: opacity 0.4s ease-in-out;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .ellipsis {
      height: 20px;
      line-height: 20px;
      padding: 0 10px;
      margin: 10px 0 10px 0;
      font-size: 14px;
      white-space: normal !important;
      word-wrap: break-word;
      word-break: break-all;
      cursor: pointer;

      &:hover {
        color: #338efc;
      }
    }
  }

  .hot-type {
    padding: 14px 12px;
    font-size: 12px;

    >a {
      display: block;
      width: 33%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: auto;

      &:nth-of-type(1) {
        float: left;
        color: $sc_3;

        >span {
          display: inline-block;
          vertical-align: middle;
          width: 25px;
          height: 25px;
          -moz-border-radius: 50%;
          border-radius: 50%;
          overflow: hidden;

          >img {
            width: 100%;
            height: 100%;
            vertical-align: top;
          }
        }
      }
    }

    .hold-time {
      float: right;
      line-height: 25px;
      color: #666;
    }
  }
}

.areaDialog {
  .el-dialog__body {
    span {
      line-height: 32px;
      margin: 0 10px;
    }
  }
}

.el-dialog {
  .el-dialog__header {
    background-color: #338efc;
    padding: 8px 20px 8px;
  }

  .el-dialog__body {
    padding: 30px 40px 40px;
  }

  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }

  .el-dialog__headerbtn {
    top: 8px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 24px;
  }

  .el-dialog__headerbtn .el-dialog__close:hover {
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>
